import React from 'react';
import { Modal, Panel, PanelType } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

interface AddCustomerSurfaceProps {
    children: React.ReactNode;
    isOpen: boolean;
    onDismiss: () => void;
    useDrawer: boolean;
    testId: string;
    enableEventBubbling?: boolean;
    isEdit?: boolean;
}

const AddCustomerSurface: React.FC<AddCustomerSurfaceProps> = ({
    children,
    isOpen,
    onDismiss,
    useDrawer,
    testId,
    enableEventBubbling = false,
    isEdit = false,
}) => {
    const { t } = useTranslation();
    const addCustomerLabel = t(isEdit ? 'Edit Customer' : 'Add Customer');
    const wasOpenRef = React.useRef(false);
    const activeUseDrawerRef = React.useRef(useDrawer);

    if (!isOpen) {
        activeUseDrawerRef.current = useDrawer;
    } else if (!wasOpenRef.current) {
        activeUseDrawerRef.current = useDrawer;
    }
    wasOpenRef.current = isOpen;

    if (activeUseDrawerRef.current) {
        return (
            <Panel
                popupProps={{ ariaLabel: addCustomerLabel }}
                data-testid={`${testId}-panel`}
                layerProps={{ eventBubblingEnabled: enableEventBubbling }}
                isOpen={isOpen}
                onDismiss={onDismiss}
                isBlocking={false}
                hasCloseButton={false}
                type={PanelType.custom}
                customWidth="min(100vw, 37.8125rem)"
                closeButtonAriaLabel={t('Close')}
                className="add-impact-model add-impact-drawer"
            >
                {children}
            </Panel>
        );
    }

    const modalTitleId = `${testId}-modal-title`;

    return (
        <Modal
            titleAriaId={modalTitleId}
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={false}
            className={`add-impact-model add-impact-legacy-modal ${testId}-modal`}
        >
            <div data-testid={`${testId}-modal`}>
                <h2
                    id={modalTitleId}
                    style={{
                        position: 'absolute',
                        width: 1,
                        height: 1,
                        padding: 0,
                        margin: -1,
                        overflow: 'hidden',
                        clip: 'rect(0, 0, 0, 0)',
                        whiteSpace: 'nowrap',
                        border: 0,
                    }}
                >
                    {addCustomerLabel}
                </h2>
                {children}
            </div>
        </Modal>
    );
};

export default AddCustomerSurface;
